import SiteLayout from "@/components/site/SiteLayout";
import PageBanner from "@/components/site/PageBanner";
import Contact from "@/components/site/Contact";
import usePageMeta from "@/hooks/usePageMeta";

export default function ContactPage() {
  usePageMeta(
    "Contact Us — Gold Mind Business | Free Growth Audit",
    "Contact Gold Mind Business for a free growth audit. Call +91 79821 56791, WhatsApp us, or drop your details — we respond within 24 hours. Laxmi Nagar, Delhi."
  );
  return (
    <SiteLayout testId="contact-page">
      <PageBanner
        title="Contact Us"
        subtitle="Drop your details and we'll audit your current funnel within 24 hours — no obligation, no fluff."
      />
      <Contact />
    </SiteLayout>
  );
}
